import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const FAQ = () => (
  <section id="faq" className="relative py-24 md:py-32 bg-[#0d0d0d]">
    <div className="max-w-3xl mx-auto px-6 md:px-10">
      <div className="text-center mb-14">
        <Reveal><Eyebrow>Questions</Eyebrow></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-heading font-extrabold uppercase text-white text-4xl md:text-5xl lg:text-6xl tracking-tight mt-3">
            Frequently <span className="text-[#F56FB4]">Asked</span>
          </h2>
        </Reveal>
      </div>

      <Reveal>
        <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-white/10 bg-[#161616]/70 backdrop-blur-xl px-6 overflow-hidden"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-heading font-semibold text-lg text-white hover:no-underline hover:text-[#F56FB4] py-5"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/60 leading-relaxed pb-5 text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default FAQ;
